import MaintenanceExplanation from './components/MaintenanceExplanation';
import MaintenanceForm from './components/MaintenanceForm';
import classes from './index.module.scss';

const MaintenancePage = () => {
  return (
    <div className={classes.mainContainer}>
      <MaintenanceExplanation />
      <MaintenanceForm />
    </div>
  );
};

export default MaintenancePage;
